import * as yup from "yup";

const adddressSchema = {
  addressLine1: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values in address field")
    .label("Address Line 1"),
  addressLine2: yup.string().label("Address Line 2"),
  country: yup.string().required().label("Country"),
  state: yup.string().required().label("State"),
  city: yup.string().required().label("City"),
  pincode: yup
    .string()
    .required()
    .matches(/^[0-9]+$/, "Please enter a valid pin code")
    .min(6)
    .max(6)
    .label("Pincode"),
};


const getSchema = (isEdit = false) => yup.object().shape({
  companyName: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for company name")
    .label("Company Name"),
  gst: yup
    .string()
    .required()
    .matches(
      /^[A-Za-z0-9]+$/,
      "There should not be any special charachters in GST"
    )
    .test("check for space", "Please remove spaces in between", (val) => {
      if (val.split(" ").length > 1) return false;
      else return true;
    })
    .min(15)
    .max(15)
    .label("GST"),
  businessType: yup.string().required().label("Business Type"),
  pan: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for Pan")
    .matches(
      /^[A-Za-z0-9]+$/,
      "There should not be any special characters in Pan"
    )
    .test("check for space", "Please remove spaces in between", (val) => {
      if (val.split(" ").length > 1) return false;
      else return true;
    })
    .min(10)
    .max(10)
    .label("PAN"),
  cin: yup
    .string()
    .required()
    .matches(
      /^[A-Za-z0-9]+$/,
      "There should not be any special characters in Cin"
    )
    .test("check for space", "Please remove spaces in between", (val) => {
      if (val.split(" ").length > 1) return false;
      else return true;
    })
    .min(21)
    .max(21)
    .label("CIN"),
  abbreviation: yup
    .string()
    .required()
    .max(5, "Abbreviation must be at most 5 characters")
    .matches(/^(?!\s+$).+/, "Please provide a valid abbreviation")
    .label("Abbreviation"),
  priceVisible: yup.bool().required().label("Price visible to users setting"),
  allowUserPickupAddress: yup
    .bool()
    .required()
    .label("Allow users to add Pickup Address setting"),
  registeredAddress: yup.object().shape(adddressSchema).required(),
  paymentMethodsAvailable: yup
    .array()
    .min(1)
    .of(yup.string())
    .required()
    .label("Payment Method"),
  ...(!isEdit && {
    admin: yup.object().shape({
      firstName: yup
        .string()
        .required("First name is required")
        .matches(/^(?!\s+$).+/, "Please provide valid first name")
        .label("First Name"),
      lastName: yup
        .string()
        .required("Last name is required")
        .matches(/^(?!\s+$).+/, "Please provide valid last name")
        .label("Last Name"),
      email: yup
        .string()
        .required("Email is required")
        .email("Please provide a valid email")
        .label("Email"),
      phone: yup
        .string()
        .required("Phone is required")
        .matches(/^[0-9]+$/, "Please enter a valid phone number")
        .min(10, "Phone must be exactly 10 digits")
        .max(10, "Phone must be exactly 10 digits")
        .label("Phone"),
    }),
  }),
});

export default getSchema;
